import { toFirstLowerCase, toFirstUpperCase } from 'infrastructure/functions';

import { deleteUnnecessaryEmptyLines } from '../helpers';

type TData = {
  readingTypes: [];
  doingDifferently: [];
  patientGoalSetting: null | string;
  whichPerson: string;
  otherPerson: string;
};

const joinArray = (arr: string[]) => arr?.join(', ');

export const generateNormalReadingsMessage = <T extends TData>(data: T) => {
  const {
    readingTypes,
    doingDifferently,
    patientGoalSetting = '',
    whichPerson,
    otherPerson,
  } = data;
  let message = '';
  const isPatient = whichPerson === 'Patient';
  const target =
    whichPerson === 'Other'
      ? toFirstLowerCase(otherPerson as string)
      : toFirstLowerCase(whichPerson as string);

  const speakWith = isPatient ? 'patient' : `${target}`;

  const speakWithUpperCase = isPatient
    ? 'Patient'
    : `${toFirstUpperCase(target)}`;

  if (readingTypes.length > 0) {
    message += `Patient has had one month of normal ${joinArray(
      readingTypes,
    )} readings. `;
  }
  if (whichPerson === 'Patient') {
    message += `MA congratulated the ${speakWith}. `;
  }

  if ((doingDifferently.length as number) === 1) {
    message += `${speakWithUpperCase} reports ${joinArray(
      doingDifferently,
    )} as having a positive impact on their readings. `;
    message += '\n';
  }
  if ((doingDifferently.length as number) > 1) {
    message += `${speakWithUpperCase} reports the following as having a positive impact on their readings: ${joinArray(
      doingDifferently,
    )}. `;
    message += '\n';
  }
  if ((doingDifferently.length as number) === 0) {
    message += `${speakWithUpperCase} reports no changes in medication, diet, physical activity and stress level. `;
    message += '\n';
  }
  if (patientGoalSetting) {
    message += `MA worked with ${speakWith} to identify healthcare goals and barriers to achieving them. `;
    message += '\n';
    message += `${patientGoalSetting} `;
  }

  message = deleteUnnecessaryEmptyLines(message);
  return message;
};
